module.exports = __webpack_public_path__ + "static/img/wholeIcon.251b0c01.png";